import axios from 'axios';
import { quoteSyncService } from '@/services/quote-sync.service';

const initialState = () => ({
  quoteSyncs: [],
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getQuoteSyncs({ commit }, { profileIds, quoteIds, cancelToken }) {
    commit('GET_QUOTE_SYNCS');

    return quoteSyncService.getQuoteSyncs({ profileIds, quoteIds, cancelToken }).then(
      (response) => {
        commit('SUCCESS_GET_QUOTE_SYNCS', response);
        return response;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ERROR_GET_QUOTE_SYNCS', error);
          throw error;
        }
      },
    );
  },
  syncQuote({ commit }, { opportunitySyncProfileId, quoteId, fieldValues }) {
    commit('SYNC_QUOTE');

    return quoteSyncService
      .syncQuote({
        opportunitySyncProfileId,
        quoteId,
        fieldValues,
      })
      .then(
        (response) => {
          commit('SUCCESS_SYNC_QUOTE', response);
          return response;
        },
        (error) => {
          commit('ERROR_SYNC_QUOTE', error);
          throw error;
        },
      );
  },
};

const mutations = {
  GET_QUOTE_SYNCS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_GET_QUOTE_SYNCS(state, quoteSyncs) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.quoteSyncs = quoteSyncs;
  },
  ERROR_GET_QUOTE_SYNCS(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
    state.quoteSyncs = [];
  },
  SYNC_QUOTE(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS_SYNC_QUOTE(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  ERROR_SYNC_QUOTE(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error,
    };
  },
};

const getters = {
  quoteSyncs: (state) => state.quoteSyncs,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const quoteSync = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
